/* tslint:disable */

/**
 */
export class CheckControl {
    checkcontrol?: boolean;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/check-control.ts